import React from "react";
import ReactApexCharts from "react-apexcharts";
import { Empty } from "antd";
import { FormatUSD } from "../../utils/helpers/string";

const CurveGraph = ({ series, categories, graphType, barType = "area" }) => {
  const hasData =
    Array.isArray(series) &&
    series.length > 0 &&
    series[0]?.data?.some((value) => value !== null && value !== undefined);

  const options = {
    chart: {
      type: "area",
      stacked: false,
      toolbar: {
        show: false,
      },
      background: "#131313",
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 800,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
      lineCap: "round",
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: false,
        opacityFrom: 0.7,
        opacityTo: 0,
        stops: [0, 90, 100],
        colorStops: [
          {
            offset: 0,
            color: "#4bb390",
            opacity: 0.7,
          },
          {
            offset: 90,
            color: "rgba(75, 179, 144, 0.10)",
            opacity: 0.4,
          },
          {
            offset: 100,
            color: "rgba(75, 179, 144, 0.10)",
            opacity: 0,
          },
        ],
      },
    },
    colors: ["#4bb390"],
    grid: {
      show: true,
      borderColor: "#ffffff33",
      padding: {
        top: 10,
        bottom: 10,
        left: 10,
        right: 10,
      },
    },
    xaxis: {
      categories: categories || [],
      axisBorder: {
        show: true,
        color: "var(--Text-Light, rgb(176 176 176 / 30%))",
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: "var(--Text-Light, #B0B0B0)",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
        rotate: -45,
        rotateAlways: false,
        hideOverlappingLabels: true,
      },
      title: {
        text: graphType,
        style: {
          color: "var(--Text-Light, #B0B0B0)",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      labels: {
        formatter: (val) =>
          series[0]?.name === "Balance" ? `${FormatUSD(val)}` : val,
        style: {
          colors: "var(--Text-Light, #B0B0B0)",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
      title: {
        text: series[0]?.name || "Value",
        style: {
          color: "var(--Text-Light, #B0B0B0)",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
    },
    tooltip: {
      theme: "dark",
      x: {
        format: "MMM",
      },
      y: {
        formatter: (val) =>
          series[0]?.name === "Balance" ? `${FormatUSD(val)}` : val + " Trades",
      },
      style: {
        fontSize: "14px",
        fontFamily: "Manrope, sans-serif",
      },
      marker: {
        show: true,
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 250,
          },
          xaxis: {
            labels: {
              style: {
                fontSize: "12px",
              },
              rotate: -45,
            },
            title: {
              style: {
                fontSize: "12px",
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: "12px",
              },
            },
            title: {
              style: {
                fontSize: "12px",
              },
            },
          },
        },
      },
    ],
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {hasData ? (
        <ReactApexCharts
          options={options}
          series={series}
          type={barType}
          height={330}
          width="100%"
        />
      ) : (
        <div
          className="no-data-message"
          style={{
            height: "330px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            color: "#fff",
            background: "#131313",
            borderRadius: "8px",
          }}
        >
          <Empty
            description={
              <span style={{ color: "#fff" }}>No Data Available</span>
            }
          />
        </div>
      )}
    </div>
  );
};

export default CurveGraph;
